import { render } from "./LinkedInNetFollowersChart.vue?vue&type=template&id=2320b952&scoped=true&ts=true"
import script from "./LinkedInNetFollowersChart.vue?vue&type=script&lang=ts"
export * from "./LinkedInNetFollowersChart.vue?vue&type=script&lang=ts"

import "./LinkedInNetFollowersChart.vue?vue&type=style&index=0&id=2320b952&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2320b952"]])

export default __exports__